<template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px;  ">
 
                <span style="font-size:12px;margin-right:10px;margin-left:3px">起始工作日期</span>
                <el-date-picker  :clearable="false" :editable="false" type="date"  v-model="v_frdttm" size="small" value-format="yyyy-MM-dd" style="width:140px" ></el-date-picker>
                <span style="font-size:12px;margin-right:10px;margin-left:10px">结束工作日期</span>
                <el-date-picker :clearable="false"  :editable="false"  type="date"  v-model="v_todttm" size="small" value-format="yyyy-MM-dd" style="width:140px" ></el-date-picker>
                <el-button type="danger" size="mini" @click="getQryList" style="margin-left:10px" icon="iconfont icon-jinduchaxun">查询</el-button>
            </div>
        </div>  
        <el-table  :data="poData" 
              border                            
              size="small"   
              v-loading="loading"
              
              :cell-style="cellStyle"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              class="custom-table-border"
              ref="refstk"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60"  ></el-table-column>
            <el-table-column  v-for="(item ,index) in poCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:11px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark" style="width:100%">已审核</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark" style="width:100%">未审核</el-tag>  
                        <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                    </template>
            </el-table-column>  
             <el-table-column
                fixed="right"
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope">
 
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">查看 </span></el-link>    
      
 
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
 
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:14px;padding-left:5px;font-weight:700">日志明细：{{v_title}}</span>
            </div>
            <div style=" border-top:1px solid #389;width:99%;height:92vh;margin-right:2px"  >
                <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px">
                    <div style="width:55px;padding-left:2px; border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">开始时间</div>
                    <div style="width:55px;padding-left:2px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">结束时间</div>
                    <div style="width:64%;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">工作内容</div>
                    <div style="width:90px;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">关联任务单号</div>
                    <div  style="width:140px;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600; ">任务名称</div>
                    <div  style="width:15%;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600">备注</div>
                </div>
                <div style="overflow-y:auto;height:95%; margin-right:2px;background:white ">
                    <span v-for="(item,index) in timeArr " :key="index" >
                        <div >
                            <div style="line-height:30px;height:30px;background:#ccc; padding-left:6px;margin-bottom:6px;margin-right:2px">
                                <span style="font-size:12px;font-weight:700;color:#389;"> 工作日期：{{item.DAYDTTM}}【{{item.WEEK}}】 </span>
                            </div>
                            <span v-for="(subitem,subindex) in dayArr.filter(it=>it['IDSEQ']==item['IDSEQ']) " :key="subindex" >
                                <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px;margin-right:2px">
                                    <div style="width:55px;padding-left:5px; border-right:1px solid #ccc">{{subitem['FRTIME']}}</div>
                                    <div style="width:55px;padding-left:5px;border-right:1px solid #ccc">{{subitem['TOTIME']}}</div>
                                    <div :title="subitem['TITLE']" style="width:64%;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['TITLE']}}</div>
                                    <div style="width:90px;padding-left:5px;border-right:1px solid #ccc">{{subitem['REFWKNO']}}</div>
                                    <div :title="subitem['JOBDESC']" style="width:140px;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['JOBDESC']}}</div>
                                    <div :title="subitem['RMK']" style="width:15%;padding-left:5px;border-right:1px solid #ccc; white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['RMK']}}</div>
                                </div>
                            </span>
                        </div>
                    </span>
                </div>
            </div>
        </el-dialog>
 
 
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate2} from '../../api/Select' 
  
 
export default {
    name:'work_summary',
    data () {
        return {
    
            finWin:false,
            v_frdttm:'',
            v_todttm:'',
            logWin:false,
            qryCond:'',
            v_title:'',

            dayArr:[],
            comboArr:[],
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            supRow:{
                SUPNO:'' ,//供应商编码
                SUPNM:'', //供应商名称
                RMK:'', //备注
            },
            rowDtl:{},
            delPrdArr:[],
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            v_row:{},
            selparam:'IDNO',
            txtparam:'',
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            options: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
 
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            poCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            stfgBool:true,
            colorx:'#e00e66', //作废颜色
            v_idseq: '',
            dtlIndex:'',
            notNull:[],
            selAll:'N',
            payData:[],
 
            timeArr:[],
   
            nextData:[],
            v_loginurl:'xuper_auth/getTableRecMany', //api请求路径
            chkIndex: 0,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            delImg:[],
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
 
            v_tabRow:{},
            v_tabIndex:'',
            v_table:'',
            tableCol :[],
            v_key:'',
            v_key2 :'',
            v_value2 :'',
        
 
        }
    },
    components: {
 
 
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 163) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 490) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
    },
    mounted () {
        this.showkey()
        
        getBaseData(this.v_loginurl ,'userno',this.v_username,'frmidseq','434669','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','434669','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
  
    },
    created () {
        this.v_frdttm =getDate2(7)
        this.v_todttm =getDate2(1)
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getQryList('') // 查询   
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //单元格样式 :cell-style="{padding:'5px','color':'black','font-size':'12px'}"
        cellStyle({row,column}){
            if (column.property=='PCT' ){
                return {background:'linear-gradient(to right,#2e9bcfcc 0%,#4fcfd5cc '+row.PCT+'%'+',transparent 0%) !important',textAlign:'center',padding:'5px' }
            }else{
                return {padding:'5px','color':'black','font-size':'12px'}
            } 
        },
        //
        dayList(v_userno){
            this.timeArr=[]
            let v_cond =' and daydttm between \''+this.v_frdttm+'\' and \''+this.v_todttm+'\''
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'userno', p_value: v_userno, p_cond:v_cond+' and ty=\'WORK\' AND corpid='+this.v_corpid+' order by Tdttm' ,p_table:'V_hr_msg'},
            }).then(res=>{
                if (res.code=='200'){
                    this.timeArr =res.result                          
                    getTabColOrData(this.v_loginurl,'v_hr_msgdtl','corpid',this.v_corpid,'userno',v_userno,'','',v_cond+' order by LSTSEQ').then((res) => {               
                        if (res.code=='200'){
                            this.dayArr =res.result         
                        }else{
                            this.promptWin =true
                            this.prompt =res.result
                        }
                    })   
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }         
            })
        },
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
 
  
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
 
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT'||column.property==='ACTQTY' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'434669',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //编辑记录
        editRec(row,val,index){
 
            this.v_title=row['EMPNM']+' ( '+row['DEPTNM'] +' )'
            //入库明细
            this.repWin=true     
            this.dayList(row['USERNO']) 
        },
 
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
 
        //状态查询
        stfgChange(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
 
            this.getQryList(cond_)
        }, 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current=index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
     
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
 
        //查询界面
        getQryList(cond){
            let v_cond =' where cdttm between \''+this.v_frdttm+'\' and \''+this.v_todttm+'\' and corpid='+this.v_corpid
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select userno, min(cdttm) frdttm,max(cdttm) todttm,max(empnm) empnm,max(deptnm) deptnm,sum(ttl) TTL,sum(wkttl) wkttl,case when sum(ttl)>0 then round(sum(wkttl)/sum(ttl)*100,1)  else 0 end pct from V_HR_MSGDTL_GP'+v_cond+' group by userno'},
            }).then(res=>{ 
                this.allList =res.result 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refstk.doLayout()
                    
                }) 
                if (this.allList.length>0){
                    this.$refs['refstk'].setCurrentRow(this.allList[0])
                }
                this.initPage() 
            })
 
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(vm.v_loginurl, 'v_sys_form_fld','idseq','434669','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
 
 
 
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        width: 32%;
        height:20px !important;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>